// extracted by mini-css-extract-plugin
export default {"cls1":"AddPayeeError-ErrorText_cls1__Gmb-6","cls2":"AddPayeeError-ErrorText_cls2__cWsee AddPayeeError-ErrorText_cls1__Gmb-6"};